import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThunderstormIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thunderstorm"}/>
}
